import React from 'react';
import { CheckIcon, BookOpenIcon, MessagesSquareIcon } from 'lucide-react';
import { Section, Reveal } from './Section';
const checks = ['Conceptos sin humo, explicados para que los entiendas de verdad.', '3 estrategias aplicables, no teoría suelta.', 'Guía de backtesting para validar antes de arriesgar.', 'Gestión de riesgo integrada desde el primer día.', 'Casos reales analizados, con aciertos y errores.'];
export function SolutionSection() {
  return <Section id="solucion" className="border-y border-white/5 bg-ink-900" data-id="element-226" data-mp="12hvfmjffbzk">
      <Reveal data-id="element-227" data-mp="3t7vkdapxnto4">
        <h2 className="font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl lg:text-4xl" data-id="element-228" data-mp="3t852yd8neyjs">
          <span aria-hidden="true" data-id="element-229" data-mp="5vb1cdqmsqd8">🏆</span> Capital Consciente — Ebook + Discord
          + 3 Bonos
        </h2>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-gray-400 sm:text-lg" data-id="element-230" data-mp="ksbtgicqinc8">
          Capital Consciente no es una promesa de resultados. Es el mismo camino
          de aprendizaje que encontrarías en una mentoría privada — conceptos
          claros, estrategias con fundamento, gestión de riesgo desde el primer
          día — sin pagar la barrera de entrada de $500 USD.
        </p>
      </Reveal>

      <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-231" data-mp="3fb0ydbbalnjl">
        <Reveal delay={0.05} data-id="element-232" data-mp="3fdn7hfdu0b3x">
          <div className="h-full rounded-2xl border border-white/10 bg-ink-850 p-6" data-id="element-233" data-mp="3kawtsm5xc6nj">
            <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-brand-soft" data-id="element-234" data-mp="3p9q6wdhatvn6">
              <BookOpenIcon className="h-5 w-5 text-brand" data-id="element-235" data-mp="3u8b9gjk0wres" />
            </div>
            <h3 className="font-display text-lg font-bold text-white" data-id="element-236" data-mp="3u68aha0w7nxx">
              📘 Ebook
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-gray-400" data-id="element-237" data-mp="6vh7uk20aj88">
              Conceptos básicos + 3 estrategias + guía de backtesting.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.12} data-id="element-238" data-mp="bsqwhxhkmqv0">
          <div className="h-full rounded-2xl border border-white/10 bg-ink-850 p-6" data-id="element-239" data-mp="gt52l9zm3qqe">
            <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-brand-soft" data-id="element-240" data-mp="2cwjlkhnf0m88">
              <MessagesSquareIcon className="h-5 w-5 text-brand" data-id="element-241" data-mp="27y8egeoi8ptp" />
            </div>
            <h3 className="font-display text-lg font-bold text-white" data-id="element-242" data-mp="2mmmeyiyg8273">
              💬 Discord
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-gray-400" data-id="element-243" data-mp="2hve4djlduasc">
              Análisis y actualizaciones continuas. No señales, no promesas.
            </p>
          </div>
        </Reveal>
      </div>

      <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-244" data-mp="2rm8uiz1r1uj2">
        {checks.map((c, i) => <Reveal key={c} delay={i * 0.05} data-id="element-245" data-mp="35lgrdlafwqk3" data-mpi={i}>
            <li className="flex items-start gap-3" data-id="element-246" data-mp="35k5r3vg7e0xq">
              <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-brand-soft" data-id="element-247" data-mp="30mdx8vw004qw">
                <CheckIcon className="h-4 w-4 text-brand" data-id="element-248" data-mp="1b6xrlqha915r" />
              </span>
              <span className="text-sm text-gray-300 sm:text-base" data-id="element-249" data-mp="168cs5t9uulid">{c}</span>
            </li>
          </Reveal>)}
      </ul>
    </Section>;
}